/* tslint:disable */
/* eslint-disable */
/**
 * Capture config API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * CompanyApi - axios parameter creator
 */
export const CompanyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Creates missing platform modules for a company based on company id and module id
         * @param {number} [id]
         * @param {number} [companyId]
         * @param {boolean} [inherit]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlatformAppByAppId: async (id, companyId, inherit, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/AddPlatformAppByAppId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }
            if (inherit !== undefined) {
                localVarQueryParameter['inherit'] = inherit;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit a company
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {CompanyViewModel} [companyViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyEdit: async (id, authorization, authVersion, companyView, companyViewModel, options = {}) => {
            const localVarPath = `/v1/Company/CompanyEdit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(companyViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Creates a Company
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {CompanyViewModel} [companyViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany: async (authorization, authVersion, companyView, companyViewModel, options = {}) => {
            const localVarPath = `/v1/Company/CreateCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(companyViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {CompanyViewModel} [companyViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyV2: async (authorization, authVersion, companyView, companyViewModel, options = {}) => {
            const localVarPath = `/v1/Company/CreateCompanyV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(companyViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Creates missing platform modules for a role based on role id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModulesByRoleId: async (id, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/CreateModulesByRoleId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUnsCompanyStructure: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/CreateUnsCompanyStructure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a company, its loggers, its teams, its databases and its users by company id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany: async (id, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/DeleteCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a plaftormApp from a company by id
         * @param {number} [companyId]
         * @param {number} [appId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlatformAppFromCompany: async (companyId, appId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/DeletePlatformAppFromCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }
            if (appId !== undefined) {
                localVarQueryParameter['appId'] = appId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a theme
         * @param {number} [companyId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTheme: async (companyId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/DeleteTheme`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['CompanyId'] = companyId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit a company\'s tags using a list of key=value strings
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCompanyTags: async (id, authorization, authVersion, companyView, requestBody, options = {}) => {
            const localVarPath = `/v1/Company/EditCompanyTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all companies and their parent
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanies: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetAllCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all companies with extra detail info
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompaniesAsTable: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetAllCompaniesAsTable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all companies with extra detail info
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompaniesNameId: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetAllCompaniesNameId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all platform modules (Admin)
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPlatformModules: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetAllPlatformModules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all modules for the specified company
         * @param {number} [companyId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAppsByCompanyId: async (companyId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetCompanyAppsByCompanyId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns company by ID
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyById: async (id, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetCompanyById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyByIdV2: async (id, authorization, authVersion, companyView, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyByIdV2', 'id', id);
            const localVarPath = `/v1/Company/GetCompanyByIdV2/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns company by name
         * @param {string} [name]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyByName: async (name, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetCompanyByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns companyId by name
         * @param {string} [name]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyIdByName: async (name, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetCompanyIdByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all extra info needed for the device configeditor => fe. plc types, roles,...
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigInfo: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetConfigInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns id and company name for the current token, used for platform users that can\'t view or have rights to companies
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCompany: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetCurrentCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all missing modules for the specified company
         * @param {number} [companyId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMissingCompanyAppsByCompanyId: async (companyId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetMissingCompanyAppsByCompanyId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all platform roles and their level
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformInfo: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetPlatformInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the theme for your company
         * @param {number} [companyId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheme: async (companyId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/GetTheme`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit a company\'s tags using a dictionary of tag names and their corresponding values
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {{ [key: string]: Array<string>; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCompanyTags: async (id, authorization, authVersion, companyView, requestBody, options = {}) => {
            const localVarPath = `/v1/Company/SetCompanyTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['authVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['companyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchCaptureCompany: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Company/SwitchCaptureCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit the theme of your company
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {ThemeCreationViewModel} [themeCreationViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        themeEdit: async (authorization, authVersion, companyView, themeCreationViewModel, options = {}) => {
            const localVarPath = `/v1/Company/ThemeEdit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(themeCreationViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CompanyApi - functional programming interface
 */
export const CompanyApiFp = function (configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration);
    return {
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Creates missing platform modules for a company based on company id and module id
         * @param {number} [id]
         * @param {number} [companyId]
         * @param {boolean} [inherit]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPlatformAppByAppId(id, companyId, inherit, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPlatformAppByAppId(id, companyId, inherit, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.addPlatformAppByAppId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit a company
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {CompanyViewModel} [companyViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyEdit(id, authorization, authVersion, companyView, companyViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyEdit(id, authorization, authVersion, companyView, companyViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.companyEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Creates a Company
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {CompanyViewModel} [companyViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCompany(authorization, authVersion, companyView, companyViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCompany(authorization, authVersion, companyView, companyViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.createCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {CompanyViewModel} [companyViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCompanyV2(authorization, authVersion, companyView, companyViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCompanyV2(authorization, authVersion, companyView, companyViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.createCompanyV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Creates missing platform modules for a role based on role id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createModulesByRoleId(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createModulesByRoleId(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.createModulesByRoleId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUnsCompanyStructure(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUnsCompanyStructure(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.createUnsCompanyStructure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a company, its loggers, its teams, its databases and its users by company id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCompany(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCompany(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.deleteCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a plaftormApp from a company by id
         * @param {number} [companyId]
         * @param {number} [appId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlatformAppFromCompany(companyId, appId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlatformAppFromCompany(companyId, appId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.deletePlatformAppFromCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a theme
         * @param {number} [companyId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTheme(companyId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTheme(companyId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.deleteTheme']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit a company\'s tags using a list of key=value strings
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editCompanyTags(id, authorization, authVersion, companyView, requestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editCompanyTags(id, authorization, authVersion, companyView, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.editCompanyTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all companies and their parent
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCompanies(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCompanies(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getAllCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all companies with extra detail info
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCompaniesAsTable(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCompaniesAsTable(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getAllCompaniesAsTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all companies with extra detail info
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCompaniesNameId(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCompaniesNameId(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getAllCompaniesNameId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all platform modules (Admin)
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPlatformModules(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPlatformModules(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getAllPlatformModules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all modules for the specified company
         * @param {number} [companyId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyAppsByCompanyId(companyId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyAppsByCompanyId(companyId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyAppsByCompanyId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns company by ID
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyById(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyById(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyByIdV2(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyByIdV2(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyByIdV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns company by name
         * @param {string} [name]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyByName(name, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyByName(name, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns companyId by name
         * @param {string} [name]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyIdByName(name, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyIdByName(name, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyIdByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all extra info needed for the device configeditor => fe. plc types, roles,...
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigInfo(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigInfo(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getConfigInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns id and company name for the current token, used for platform users that can\'t view or have rights to companies
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentCompany(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentCompany(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCurrentCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all missing modules for the specified company
         * @param {number} [companyId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMissingCompanyAppsByCompanyId(companyId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMissingCompanyAppsByCompanyId(companyId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getMissingCompanyAppsByCompanyId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all platform roles and their level
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformInfo(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformInfo(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getPlatformInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the theme for your company
         * @param {number} [companyId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTheme(companyId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTheme(companyId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getTheme']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit a company\'s tags using a dictionary of tag names and their corresponding values
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {{ [key: string]: Array<string>; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCompanyTags(id, authorization, authVersion, companyView, requestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCompanyTags(id, authorization, authVersion, companyView, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.setCompanyTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async switchCaptureCompany(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.switchCaptureCompany(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.switchCaptureCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit the theme of your company
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {ThemeCreationViewModel} [themeCreationViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async themeEdit(authorization, authVersion, companyView, themeCreationViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.themeEdit(authorization, authVersion, companyView, themeCreationViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.themeEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CompanyApi - factory interface
 */
export const CompanyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CompanyApiFp(configuration);
    return {
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Creates missing platform modules for a company based on company id and module id
         * @param {number} [id]
         * @param {number} [companyId]
         * @param {boolean} [inherit]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlatformAppByAppId(id, companyId, inherit, authorization, authVersion, companyView, options) {
            return localVarFp.addPlatformAppByAppId(id, companyId, inherit, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit a company
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {CompanyViewModel} [companyViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyEdit(id, authorization, authVersion, companyView, companyViewModel, options) {
            return localVarFp.companyEdit(id, authorization, authVersion, companyView, companyViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Creates a Company
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {CompanyViewModel} [companyViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany(authorization, authVersion, companyView, companyViewModel, options) {
            return localVarFp.createCompany(authorization, authVersion, companyView, companyViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {CompanyViewModel} [companyViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyV2(authorization, authVersion, companyView, companyViewModel, options) {
            return localVarFp.createCompanyV2(authorization, authVersion, companyView, companyViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Creates missing platform modules for a role based on role id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModulesByRoleId(id, authorization, authVersion, companyView, options) {
            return localVarFp.createModulesByRoleId(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUnsCompanyStructure(authorization, authVersion, companyView, options) {
            return localVarFp.createUnsCompanyStructure(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a company, its loggers, its teams, its databases and its users by company id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany(id, authorization, authVersion, companyView, options) {
            return localVarFp.deleteCompany(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a plaftormApp from a company by id
         * @param {number} [companyId]
         * @param {number} [appId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlatformAppFromCompany(companyId, appId, authorization, authVersion, companyView, options) {
            return localVarFp.deletePlatformAppFromCompany(companyId, appId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a theme
         * @param {number} [companyId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTheme(companyId, authorization, authVersion, companyView, options) {
            return localVarFp.deleteTheme(companyId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit a company\'s tags using a list of key=value strings
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCompanyTags(id, authorization, authVersion, companyView, requestBody, options) {
            return localVarFp.editCompanyTags(id, authorization, authVersion, companyView, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all companies and their parent
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanies(authorization, authVersion, companyView, options) {
            return localVarFp.getAllCompanies(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all companies with extra detail info
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompaniesAsTable(authorization, authVersion, companyView, options) {
            return localVarFp.getAllCompaniesAsTable(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all companies with extra detail info
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompaniesNameId(authorization, authVersion, companyView, options) {
            return localVarFp.getAllCompaniesNameId(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all platform modules (Admin)
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPlatformModules(authorization, authVersion, companyView, options) {
            return localVarFp.getAllPlatformModules(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all modules for the specified company
         * @param {number} [companyId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAppsByCompanyId(companyId, authorization, authVersion, companyView, options) {
            return localVarFp.getCompanyAppsByCompanyId(companyId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns company by ID
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyById(id, authorization, authVersion, companyView, options) {
            return localVarFp.getCompanyById(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyByIdV2(id, authorization, authVersion, companyView, options) {
            return localVarFp.getCompanyByIdV2(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns company by name
         * @param {string} [name]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyByName(name, authorization, authVersion, companyView, options) {
            return localVarFp.getCompanyByName(name, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns companyId by name
         * @param {string} [name]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyIdByName(name, authorization, authVersion, companyView, options) {
            return localVarFp.getCompanyIdByName(name, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all extra info needed for the device configeditor => fe. plc types, roles,...
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigInfo(authorization, authVersion, companyView, options) {
            return localVarFp.getConfigInfo(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns id and company name for the current token, used for platform users that can\'t view or have rights to companies
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCompany(authorization, authVersion, companyView, options) {
            return localVarFp.getCurrentCompany(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all missing modules for the specified company
         * @param {number} [companyId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMissingCompanyAppsByCompanyId(companyId, authorization, authVersion, companyView, options) {
            return localVarFp.getMissingCompanyAppsByCompanyId(companyId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all platform roles and their level
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformInfo(authorization, authVersion, companyView, options) {
            return localVarFp.getPlatformInfo(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the theme for your company
         * @param {number} [companyId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheme(companyId, authorization, authVersion, companyView, options) {
            return localVarFp.getTheme(companyId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit a company\'s tags using a dictionary of tag names and their corresponding values
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {{ [key: string]: Array<string>; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCompanyTags(id, authorization, authVersion, companyView, requestBody, options) {
            return localVarFp.setCompanyTags(id, authorization, authVersion, companyView, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchCaptureCompany(authorization, authVersion, companyView, options) {
            return localVarFp.switchCaptureCompany(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit the theme of your company
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {ThemeCreationViewModel} [themeCreationViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        themeEdit(authorization, authVersion, companyView, themeCreationViewModel, options) {
            return localVarFp.themeEdit(authorization, authVersion, companyView, themeCreationViewModel, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompanyApi - object-oriented interface
 */
export class CompanyApi extends BaseAPI {
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Creates missing platform modules for a company based on company id and module id
     * @param {number} [id]
     * @param {number} [companyId]
     * @param {boolean} [inherit]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPlatformAppByAppId(id, companyId, inherit, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).addPlatformAppByAppId(id, companyId, inherit, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Edit a company
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {CompanyViewModel} [companyViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companyEdit(id, authorization, authVersion, companyView, companyViewModel, options) {
        return CompanyApiFp(this.configuration).companyEdit(id, authorization, authVersion, companyView, companyViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Creates a Company
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {CompanyViewModel} [companyViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCompany(authorization, authVersion, companyView, companyViewModel, options) {
        return CompanyApiFp(this.configuration).createCompany(authorization, authVersion, companyView, companyViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {CompanyViewModel} [companyViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCompanyV2(authorization, authVersion, companyView, companyViewModel, options) {
        return CompanyApiFp(this.configuration).createCompanyV2(authorization, authVersion, companyView, companyViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Creates missing platform modules for a role based on role id
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createModulesByRoleId(id, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).createModulesByRoleId(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUnsCompanyStructure(authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).createUnsCompanyStructure(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Removes a company, its loggers, its teams, its databases and its users by company id
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCompany(id, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).deleteCompany(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Removes a plaftormApp from a company by id
     * @param {number} [companyId]
     * @param {number} [appId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePlatformAppFromCompany(companyId, appId, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).deletePlatformAppFromCompany(companyId, appId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Removes a theme
     * @param {number} [companyId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTheme(companyId, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).deleteTheme(companyId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Edit a company\'s tags using a list of key=value strings
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editCompanyTags(id, authorization, authVersion, companyView, requestBody, options) {
        return CompanyApiFp(this.configuration).editCompanyTags(id, authorization, authVersion, companyView, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns all companies and their parent
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllCompanies(authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getAllCompanies(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns all companies with extra detail info
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllCompaniesAsTable(authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getAllCompaniesAsTable(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns all companies with extra detail info
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllCompaniesNameId(authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getAllCompaniesNameId(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns all platform modules (Admin)
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllPlatformModules(authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getAllPlatformModules(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns all modules for the specified company
     * @param {number} [companyId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyAppsByCompanyId(companyId, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getCompanyAppsByCompanyId(companyId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns company by ID
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyById(id, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getCompanyById(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyByIdV2(id, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getCompanyByIdV2(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns company by name
     * @param {string} [name]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyByName(name, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getCompanyByName(name, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns companyId by name
     * @param {string} [name]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyIdByName(name, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getCompanyIdByName(name, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns all extra info needed for the device configeditor => fe. plc types, roles,...
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConfigInfo(authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getConfigInfo(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns id and company name for the current token, used for platform users that can\'t view or have rights to companies
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentCompany(authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getCurrentCompany(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns all missing modules for the specified company
     * @param {number} [companyId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMissingCompanyAppsByCompanyId(companyId, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getMissingCompanyAppsByCompanyId(companyId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns all platform roles and their level
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlatformInfo(authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getPlatformInfo(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns the theme for your company
     * @param {number} [companyId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTheme(companyId, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getTheme(companyId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Edit a company\'s tags using a dictionary of tag names and their corresponding values
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {{ [key: string]: Array<string>; }} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setCompanyTags(id, authorization, authVersion, companyView, requestBody, options) {
        return CompanyApiFp(this.configuration).setCompanyTags(id, authorization, authVersion, companyView, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    switchCaptureCompany(authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).switchCaptureCompany(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Edit the theme of your company
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {ThemeCreationViewModel} [themeCreationViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    themeEdit(authorization, authVersion, companyView, themeCreationViewModel, options) {
        return CompanyApiFp(this.configuration).themeEdit(authorization, authVersion, companyView, themeCreationViewModel, options).then((request) => request(this.axios, this.basePath));
    }
}
